<div class="top-gap centered-container">
  <mat-card>
    <mat-card-header>
      <img
        src="{{ serviceProfileURL$ | async }}"
        mat-card-avatar
        ngClass.xs="avatar-xs"
        class="card-image"
      />
      <mat-card-title>{{ (serviceProvider$ | async)?.title }}</mat-card-title>
      <mat-card-subtitle
        >Represented by
        {{ serviceProviderUserName$ | async }}</mat-card-subtitle
      >
    </mat-card-header>
    <mat-card-content>
      <div
        *ngIf="contactMessages$ | async as contactMessages; else loading"
        fxLayout="column"
        fxLayoutAlign="start stretch"
        fxLayoutGap="12px"
      >
        <app-contact-conversation-message
          *ngFor="let conversationMessage of contactMessages"
          [isCurrentViewer]="
            conversationMessage.senderKey == (contact$ | async)?.clientUserKey
          "
          [conversationMessage]="conversationMessage"
        ></app-contact-conversation-message>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <section class="mat-typography" *ngIf="!formModelLoading">
        <form
          [formGroup]="formModel.formGroup"
          fxLayout="column"
          fxLayoutAlign="center stretch"
        >
          <mat-form-field fxFlex="100">
            <mat-label>New Message</mat-label>
            <textarea rows="5" formControlName="message" matInput></textarea>
            <mat-error *ngFor="let validator of formModel.validators.message">
              <span
                *ngIf="
                  formModel.formGroup.controls.message.hasError(validator.type)
                "
              >
                {{ validator.message }}
              </span>
            </mat-error>
          </mat-form-field>
          <button
            fxFlex="100"
            mat-raised-button
            color="primary"
            [class.spinner]="sending"
            [disabled]="sending"
            (click)="send()"
          >
            <mat-icon>send</mat-icon>
            Send
          </button>
        </form>
      </section>
    </mat-card-actions>
  </mat-card>
</div>

<ng-template #loading>
  <app-loading-spinner
    class="results-spinner"
    [show]="true"
  ></app-loading-spinner
></ng-template>
